
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.483 13H1.816c-.367 0-.721-.139-.998-.39a1.61 1.61 0 01-.51-.977 36.928 36.928 0 010-9.53c.052-.375.229-.718.5-.969.272-.25.62-.391.982-.398 2.098-.981 4.357-.981 6.716 0 .22.003.436.056.634.156.197.1.372.243.511.42.145.185.249.402.304.633.055.232.06.474.014.708a22.317 22.317 0 000 8.43c.046.234.04.476-.014.707a1.636 1.636 0 01-.304.633c-.141.18-.32.326-.522.426-.202.1-.423.152-.646.151z","fill":"url(#paint0_linear_1591_2159)"}}),_c('path',{attrs:{"d":"M7.781 4.224H2.226a.36.36 0 01-.246-.095.315.315 0 01-.102-.23c0-.086.037-.168.102-.23a.36.36 0 01.246-.095H7.78a.36.36 0 01.246.096.315.315 0 01.101.23.315.315 0 01-.101.23.36.36 0 01-.246.094zM7.781 7.15H2.226a.36.36 0 01-.246-.096.315.315 0 01-.102-.23c0-.086.037-.168.102-.23a.36.36 0 01.246-.094H7.78a.36.36 0 01.246.095.315.315 0 01.101.23.315.315 0 01-.101.23.36.36 0 01-.246.095z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1591_2159","x1":"0","y1":"0","x2":"10.138","y2":"12.891","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".078","stop-color":"#161FFE"}}),_c('stop',{attrs:{"offset":".5","stop-color":"#C96CA6"}}),_c('stop',{attrs:{"offset":".984","stop-color":"#FF9E2C"}})])])])
          )
        }
      }
    